import { Tab, Tabs } from "@blueprintjs/core";
import * as React from "react";
import { useHistory, useParams } from "react-router";

import { PageContainer } from "../../../../components";
import { useAuth } from "../../../../contexts";
import { useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { EDrupalRoutes } from "../../../EDrupalRoutes";
import { DrupalProfileChangeEmailTab } from "./DrupalProfileChangeEmailTab";
import { DrupalProfileChangePasswordTab } from "./DrupalProfileChangePasswordTab";
import { DrupalProfileDetailTab } from "./DrupalProfileDetailTab";

export interface IDrupalProfileItemPageProps {}

export const DrupalProfileItemPage: React.FunctionComponent<IDrupalProfileItemPageProps> = () => {
  const { tab } = useParams<{ tab: string }>();
  const history = useHistory();
  const { t } = useTl();

  return (
    <PageContainer>
      <Tabs
        id="TabsProfile"
        onChange={(newTabId) => history.push(`${EDrupalRoutes.profile}/${newTabId}`)}
        selectedTabId={tab}
        renderActiveTabPanelOnly
        large={true}
      >
        <Tab id="detail" title={t(ETLCodes.Detail)} panel={<DrupalProfileDetailTab />} />
        <Tab id="changePassword" title={t(ETLCodes.ChangePassword)} panel={<DrupalProfileChangePasswordTab />} />
        <Tab id="changeEmail" title={t(ETLCodes.ChangeEmail)} panel={<DrupalProfileChangeEmailTab />} />
      </Tabs>
    </PageContainer>
  );
};
